import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import {
  reportTypeOption,
  reportCategoryOption,
  reportSystemWellnessOption,
  reportLoadDistributionOption,
  reportLoadTypeOption,
  reportCategory,
  DeviceSubType,
  eventMapping,
  reportType  } from '../../../shareModel';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { CryptoService} from '../../../services/crypto.service';
import { SmartPowerReportService} from '../../../services/smart-power-report.service';
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../../store';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromFeature from '../../../my-features';
@Component({
  standalone: false,
  selector: 'app-report-detail-management',
  templateUrl: './report-detail-management.component.html',
  styleUrls: ['./report-detail-management.component.css']
})
export class ReportDetailManagementComponent implements OnInit {
  private componentDestroyed = new Subject();
  reportTypeOption: SelectItem[] = reportTypeOption;
  reportCategoryOption: SelectItem[] = reportCategoryOption;
  reportSystemWellnessOption: SelectItem[] = reportSystemWellnessOption;
  reportLoadDistributionOption: SelectItem[] = reportLoadDistributionOption;
  reportLoadTypeOption: SelectItem[] = reportLoadTypeOption;
  reportType: any = NaN;
  reportId: any = NaN;
  reportCategory: any = NaN;
  reportSystemWellness: any = NaN;
  reportLoadDistribution: any = NaN;
  reportLoadType: any = 0;

  reporDetailLogs_cols: any[] = [
    { field: 'name', header: TRANSLATE('Device Name'), width: '200', class: 'col-nowrap ellipsis' },
    { field: 'model', header: TRANSLATE('Model Name'), width: '200', class: 'col-nowrap ellipsis' },
    { field: 'type', header: TRANSLATE('Type'), width: '120', class: 'col-nowrap'},
  ];
  systemWellnessLogs = [];
  loadDistributionLogsData = [];
  loadDistributionLogs = [];
  powerQualityLogs = [];
  energySavingLogs = [];
  loadDailog = false;
  chartOption: any;
  loadChart = {};
  startTs = 0; // ts
  endTs = 0; // ts
  paramStartTs = 0; // ts
  paramEndTs = 0; // ts
  eventRangeOptions: SelectItem[] = [
    { label: '7', value: 7 },
    { label: '30', value: 30 },
  ];
  rangeOptions: SelectItem[] = [
    { label: '7', value: 7 },
    { label: '30', value: 30 },
  ];
  rangeOptionsUnit = TRANSLATE('Days');
  selectedRange: any = 7; // default
  selectedEventRange: any = 7; // default
  IsSuperAdmin = false;
  IsAdmin = false;
  isMsp = false;
  regionId: number;
  currentUser = '';
  loadCurvDateDic = {};
  region = [];
  regionOption = [];
  selectRegion = null;
  listPlaintext = '';
  selectAcode = null;
  accountInfo = null;
  ReadRegionParam = {
    MspMainRegionId: 0,
    otp: ''
  };
  
  accountLoaded = true;
  proRegionLoaded = true;
  proMainRegionId = null;

  constructor(private router: Router,
    private cryptoService: CryptoService, 
    private smartPowerReportService: SmartPowerReportService,
    private route: ActivatedRoute,
    private store: Store<fromStore.State>,
  ) {
    this.store.pipe(select(fromStore.getCurrentUser)).pipe(takeUntil(this.componentDestroyed)).subscribe(user => {
      if (user != undefined && !user.isLoading && user.isLoaded && user.isLogin) {
        this.currentUser = user.currentUser;
        this.IsSuperAdmin = user.authority === 2;
        this.isMsp = user.isMsp;
        this.regionId = user.RegionId;

        const rawHash = this.route.snapshot.paramMap.get('hashStr');

        if (rawHash) {
          try {
            const decryptedStr = this.cryptoService.aesDecrypt(rawHash);

            if (decryptedStr) {
              const params = decryptedStr.split(',');

              // 1. 本頁面 (Detail) 需要的參數
              this.reportType = parseInt(params[0], 10);
              this.reportId = parseInt(params[1], 36);       // 36 進位
              this.reportCategory = parseInt(params[2], 10); // category
              this.startTs = parseInt(params[3], 36);        // 36 進位
              this.endTs = parseInt(params[4], 36);          // 36 進位
              this.paramStartTs = parseInt(params[3], 36);
              this.paramEndTs = parseInt(params[4], 36);
              if (this.reportType == reportType.Monthly) {
                this.selectedRange = 30;
                this.selectedEventRange = 30;
              }

              // 2. 把屬於 List 的參數「明文」切出來存好
              // 因為 Detail 的參數多插了一個 category (params[2])，所以 List 參數會被擠到 index 5 之後
              const listParamsArray = params.slice(5);

              if (listParamsArray.length > 0) {
                // 存成明文字串 (例如 'AccountMgt,123')，供 goBack 使用
                this.listPlaintext = listParamsArray.join(',');
              } else {
                this.listPlaintext = '';
              }

              if (params[5] === "AccountMgt") {
                this.selectAcode = parseInt(params[6]);  // Acode
              } else if (params[5] === "MspAdmin") {
                this.isMsp = true;
                this.selectRegion = parseInt(params[6]); // MspMainRegionId
              }
              if (this.isMsp) {
                this.ReadRegionParam = {
                  ...this.ReadRegionParam,
                  MspMainRegionId: this.selectRegion,
                };
                this.selectRegion = parseInt(params[6])
                this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
              }
            }
          } catch (error) {
            console.error('解密失敗', error);
          }
        }
        if (this.reportCategory == reportCategory['Load Distribution']) {
            this.reportLoadDistribution = [0] // All
        }
        if (this.selectAcode === null) { // AccountMgt進來的暫時先不要讀取, 因為有可能是Pro的帳號
          this.dispatchFilter();
        }
      }
    });


    this.store.pipe(select(fromStore.GetSmartPowerReportData), takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res !== null && !res.isLoading && res.isLoaded) {
        if (res.entities.length > 0) {
          const tempLoadDist = [];
          const tempPowerQual = [];
          const tempEnergySav = [];
          const tempLoadCurvDic = {};
          res.entities.forEach(r => {
            const deviceType = r.DeviceType !== undefined ? r.DeviceType : 0;

            if (this.reportCategory == reportCategory['Load Distribution']) {
              const descArray: string[] = [];

              // AvgLoad 與 MaxLoad 判斷
              if (r.AvgLoad !== undefined || r.MaxLoad !== undefined) {
                if (r.AvgLoad >= 70 || r.MaxLoad >= 70) {
                  descArray.push(TRANSLATE('Device Load Approaching Peak Capacity'));
                }
              }

              // // MaxLoadLv (Peak Load) 判斷
              // if (r.MaxLoadLv !== undefined) {
              //   if (r.MaxLoadLv === 4) {
              //     descArray.push(TRANSLATE('Device Peak Load over') + " 60%");
              //   } else if (r.MaxLoadLv === 5) {
              //     descArray.push(TRANSLATE('Device Peak Load over') + " 80%");
              //   } else if (r.AvgLoadLv === 6) { // Level 6 (>100%)
              //     descArray.push(TRANSLATE('Device Peak Load over') + " 100%");
              //   }
              // }

              let desc = descArray.join(', ');
              const loadDistributionItem = {
                time: r.DataDate ? r.DataDate.replace(/-/g, '/') : '',
                dcode: r.dcode,
                deviceName: r.DeviceName,
                model: r.Model,
                type: (typeof DeviceSubType !== 'undefined' && DeviceSubType[deviceType]) ? DeviceSubType[deviceType].displayName : 'UPS',
                desc: desc,
                avgLoad: r.AvgLoad !== undefined ? r.AvgLoad : '-',
                maxLoad: r.MaxLoad !== undefined ? r.MaxLoad : '-',
                minLoad: r.MinLoad !== undefined ? r.MinLoad : '-',
                avgLoadLv: r.MaxLoad !== undefined ? r.AvgLoadLv : '-',
                maxLoadLv: r.MaxLoad !== undefined ? r.MaxLoadLv : '-',
                minLoadLv: r.MinLoadLv !== undefined ? r.MinLoadLv : '-',
              };

              // // Curve
              const dicKey = `${r.dcode}_${loadDistributionItem.time}`;
              if (tempLoadCurvDic[dicKey] === undefined) {
                tempLoadCurvDic[dicKey] = r;
              }
              tempLoadDist.push(loadDistributionItem);
            } else if (this.reportCategory == reportCategory['UPS Protection and Power Anomaly']) {
              const d = new Date(r.ts * 1000);
              const fomatDate = `${d.getUTCFullYear()}/${d.getUTCMonth() + 1}/${d.getUTCDate()}`;
              const powerQualityItem = {
                time: fomatDate,
                dcode: r.dcode,
                deviceName: r.DeviceName,
                model: r.Model,
                type: (typeof DeviceSubType !== 'undefined' && DeviceSubType[deviceType]) ? DeviceSubType[deviceType].displayName : 'UPS',
                routeLink: "/monitoring/device/detail/" + this.cryptoService.aesEncrypt(r.DeviceSN),
                desc: eventMapping[r.event_number] !== undefined ? eventMapping[r.event_number].desc : ''
              };
              tempPowerQual.push(powerQualityItem);

            } else if (this.reportCategory == reportCategory['Estimated Consumption']) {
              const energyItem = {
                dcode: r.dcode,
                deviceName: r.DeviceName,
                model: r.Model,
                type: (typeof DeviceSubType !== 'undefined' && DeviceSubType[deviceType]) ? DeviceSubType[deviceType].displayName : 'UPS',
                routeLink: "/monitoring/device/detail/" + this.cryptoService.aesEncrypt(r.DeviceSN),
                consumption: r.Consumption !== undefined ? r.Consumption !== 0 ? Number((r.Consumption / 1000).toFixed(2)) : 0 : '-',
                lastConsumption: r.LastConsumption !== undefined ? r.LastConsumption !== 0 ? Number((r.LastConsumption / 1000).toFixed(2)) : 0 : '-',
                co2e: r.CO2e !== undefined ? r.CO2e !== 0 ? Number((r.CO2e / 1000 / 1000).toFixed(2)) : 0 : '-', //kg
                lastCo2e: r.LastCO2e !== undefined ? r.LastCO2e !== 0 ? Number((r.LastCO2e / 1000 / 1000).toFixed(2)) : 0 : '-', //kg
              };
              tempEnergySav.push(energyItem);
            }
          });

          // 組裝完成後，一次性賦值給畫面變數, 依照時間降冪排序
          this.loadDistributionLogsData = [...tempLoadDist].sort((a, b) => {
            return new Date(b.time).getTime() - new Date(a.time).getTime();
          });
          this.powerQualityLogs = [...tempPowerQual].sort((a, b) => {
            return new Date(b.time).getTime() - new Date(a.time).getTime();
          });
          this.energySavingLogs = tempEnergySav;
          this.loadCurvDateDic = tempLoadCurvDic;
          this.reportFilter();
        } else {
          // 沒資料時再清空
          this.loadDistributionLogsData = [];
          this.loadDistributionLogs = [];
          this.powerQualityLogs = [];
          this.energySavingLogs = [];
          this.loadCurvDateDic = {};
        }
      }
    });

    
        
    this.store.select(fromStore.getSingleAccountInfo(this.selectAcode)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
          if (res) {
            this.accountInfo = res;
            if (res.OriginCompanyId !== undefined && res.OriginCompanyId !== res.CompanyId) {
              this.isMsp = true;
              this.regionId = res.CompanyId;
              this.ReadRegionParam = {
                ...this.ReadRegionParam,
                MspMainRegionId: res.CompanyId,
              };
              this.proRegionLoaded = false;
              this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
            }
            this.accountLoaded = true;
            this.dispatchFilter();
          }
        });
        
        this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
          if (res && res.length > 0) {
            this.region = res;
    
            this.regionOption = [...this.region]
              .sort((a: any, b: any) => a.Id - b.Id)
              .map(r => ({
                label: r.Region,
                value: r.Id
              }));
    
            if (this.selectRegion != null) {
    
              const isExist = this.regionOption.some(opt => opt.value == this.selectRegion);
    
              if (!isExist) {
                this.selectRegion = null;
              } else {
                this.selectRegion = Number(this.selectRegion);
              }
            }
            this.proRegionLoaded = true;
          }
        });

    // this.systemWellnessLogs = [
    //   {
    //     "time": "2025/10/20 13:47:17",
    //     "model": "CP1500PFCLCD",
    //     "name": "IDF_123",
    //     "type": "UPS",
    //     "routeLink": "/detail/CP1500PFCLCD",
    //     "status": "critical",
    //     "statusCode": 2,
    //     "desc": "Communication with the UPS has been lost",
    //     "icon": "fa-times-circle"
    //   },
    // ]
  }

  ngOnInit() {
    this.getReportDetailLogs();
    this.chartOption = {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            font: {
              size: 12
            }
          }
        },
        datalabels: {
          display: false,
        },
      },
      scales: {
        y: {
          ticks: {
            min: 0,
            padding: 10,
            color: '#666666',
          },
          grid: {
            drawTicks: false,
            color: '#f0f0f0'
          }
        }
      },
    };
    if (this.reportCategory == reportCategory['Load Distribution']) {
      this.reportLoadDistribution = [0] // defaul all
    }
  }

  goBack() {
    // 1. 確保 ID 與 Timestamp 轉回 36 進位壓縮格式
    const shortId = Number(this.reportId).toString(36);
    const shortStart = Number(this.paramStartTs).toString(36);
    const shortEnd = Number(this.paramEndTs).toString(36);

    // 2. Preview 頁面的格式：type, id, start, end
    let paramStr = `${this.reportType},${shortId},${shortStart},${shortEnd}`;

    // 3. 把 List 頁面的明文接在最後面 (這會變成 Preview 頁面的 params.slice(4))
    if (this.listPlaintext && this.listPlaintext !== '') {
      paramStr = `${paramStr},${this.listPlaintext}`;
    }

    // 4. 全部組合好後進行一次加密
    const hashStr = this.cryptoService.aesEncrypt(paramStr);

    // 5. 退回 Preview 頁面
    this.router.navigate(['/management/smart-power-report/report/', hashStr]);
  }

  getReportDetail() {
    // this.reportType = this.reportType;
    // this.reportCategory = this.reportCategory;
    this.reportSystemWellness = 0;
    this.reportLoadDistribution = [0] // defaul all
  }

  dispatchFilter(e: any = null, isUiOnly: boolean = false) {

    if (isUiOnly) {
      return;
    }

    if (this.reportCategory == reportCategory['Load Distribution']) {
      if (e == 'selectReportCategory') {
      this.reportLoadDistribution = [0] // defaul all
      } else if (this.reportLoadDistribution.length === 0) {
        this.loadDistributionLogs = [];
        return;
      }
    }

    // 2. 判斷目前該用哪一個 Range 變數
    let rangeDays = 7; // 給個預設值
    if (this.reportType === 1) { // monthly
      rangeDays = 30;
    }
    if (this.reportCategory === null || this.reportCategory === 1) {
      rangeDays = this.selectedEventRange;
    } else if (this.reportCategory === 0 || this.reportCategory === 2) {
      rangeDays = this.selectedRange;
    }

      const calculatedEndTs = Math.floor(Date.now() / 1000);
      const calculatedStartTs = calculatedEndTs - (86400 * rangeDays); //減去選擇的天數
      this.startTs = calculatedStartTs;
      this.endTs = calculatedEndTs;

    // 4. 組合 API 參數
    const params = {
      otp: '',
      DataType: this.reportCategory,
      StartDate: calculatedStartTs,
      EndDate: calculatedEndTs,
    } as any;

    if (this.isMsp) {
      if (this.selectRegion !== null) {
        params.RegionId = this.selectRegion;
      } else {
        params.RegionId = this.regionId;
      }
    }
    if (this.selectAcode !== null) {
      params.acode = this.selectAcode;
    }

    // if (this.reportCategory == reportCategory['Load Distribution']) {
    //   params.LoadLv = this.reportLoadDistribution.includes(0) ? [] : this.reportLoadDistribution;
    // }

    this.store.dispatch(new fromFeature.GetSmartPowerReportData(params));
    this.getReportDetailLogs();
  }

  getReportDetailLogs() {
    const logs = [
      // this.systemWellnessLogs,
      this.loadDistributionLogs,
      this.powerQualityLogs,
      this.energySavingLogs
    ];

    return logs[this.reportCategory];
  }

    getVisibleColumnsCount(): number {
    let count = this.reporDetailLogs_cols.length;

    if (this.reportCategory === null) {
      count += 1; // Status
      count += 1; // Time
      count += 1; // Description
    } else if (this.reportCategory === 0) {
      count += 1; // Time
      count += 2; // Peak Load + Avg Load
      count += 1; // Description
    } else if (this.reportCategory === 1) {
      count += 1; // Time
      count += 1; // Description
    } else if (this.reportCategory === 2) {
      count += 2; // Estimated Consumption + Estimated Carbon Footprint
    }

    return count;
  }

  onLoadDistributionNameClick(event) {
    if (event !== null) {
      this.smartPowerReportService.SetLoadDistributionDevice = event.dcode
      this.router.navigate(['status']);
    }
  }
  
  reportFilter(e: any = null) {
    if (this.loadDistributionLogsData !== null && this.loadDistributionLogsData.length > 0) {
      let selectReportLoadDistribution = []
      selectReportLoadDistribution = this.reportLoadDistribution;
      if (this.reportCategory == reportCategory['Load Distribution'] && e !== null && e.value) {
        const value = e.value as number[];
        const clicked = e.itemValue;

        if (clicked === 0) {
          this.reportLoadDistribution = value.includes(0) ? [0] : [];
        } else {
          // 因為Spec調整, 由原本的百分比區間1~6改為3個, 小於40%代表1、2, 40~70代表3、4,大於70就是5、6
          // 1: 0 <= x <= 20;
          // 2: 20 < x < 40;
          // 3: 40 < x <= 50;
          // 4: 50 < x <= 70;
          // 5: 70 < x <=100;
          // 6: x > 100
          const filteredValue = value.filter(v => v !== 0);
          this.reportLoadDistribution = filteredValue;
          const tempResult = [];
          filteredValue.forEach(v => {
            if (v === 1) tempResult.push(1, 2);
            if (v === 2) tempResult.push(3, 4);
            if (v === 3) tempResult.push(5, 6);
          });
          
          selectReportLoadDistribution = tempResult;
        }
      }
      this.loadDistributionLogs = [];
      
      this.loadDistributionLogsData.forEach(l => {
        if (this.reportLoadType != null && !isNaN(this.reportLoadType)) {
          let isMatch = false;
          
          // 取得勾選的百分比陣列
          const selectedLevels = selectReportLoadDistribution || [];

          if (selectedLevels.length === 0) {
            isMatch = false; 
          } 
          else {
            const isSelectAllLevels = selectedLevels.includes(0); // 是否勾選了代表 All 的 0

            // 根據 ReportType 進行比對
            if (this.reportLoadType == 1) { 
              // 情況 A：Peak Load
              if (l.maxLoadLv !== undefined && (isSelectAllLevels || selectedLevels.includes(l.maxLoadLv))) {
                isMatch = true;
              }
            } 
            else if (this.reportLoadType == 2) { 
              // 情況 B：Avg. Load
              if (l.avgLoadLv !== undefined && (isSelectAllLevels || selectedLevels.includes(l.avgLoadLv))) {
                isMatch = true;
              }
            } 
            else { 
              // 情況 C：All (不分 Peak 或 Avg)
              // 只要該設備的 Max 或 Avg "任何一個" 有符合勾選的百分比，就讓它顯示
              const matchMax = l.maxLoadLv !== undefined && (isSelectAllLevels || selectedLevels.includes(l.maxLoadLv));
              const matchAvg = l.avgLoadLv !== undefined && (isSelectAllLevels || selectedLevels.includes(l.avgLoadLv));
              
              if (matchMax || matchAvg) {
                isMatch = true;
              }
            }
          }

          // 成功 Match 才塞入陣列顯示於畫面
          if (isMatch) {
            this.loadDistributionLogs.push(l);
          }
        }
      });
    }
  }

  showLoadDailog(dcode: string, dataDate: string) {
    // 1. 如果根本沒有字典，直接中斷
    if (!this.loadCurvDateDic) {
      this.loadDailog = false;
      return;
    }

    // 2. 計算基準日期與 7 天邊界 (保留撞牆平移邏輯)
    const clickedDate = new Date(dataDate);
    clickedDate.setHours(0, 0, 0, 0);

    const minDate = new Date((this.startTs || 0) * 1000);
    minDate.setHours(0, 0, 0, 0);

    const today = new Date();
    // 【修改點】：將最大邊界 (maxDate) 設為「昨天」
    const maxDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    maxDate.setHours(0, 0, 0, 0);

    let startDate = new Date(clickedDate);
    startDate.setDate(startDate.getDate() - 3);

    let endDate = new Date(clickedDate);
    endDate.setDate(endDate.getDate() + 3);

    // 判斷是否撞牆
    if (startDate < minDate) {
      startDate = new Date(minDate);
      endDate = new Date(minDate);
      endDate.setDate(endDate.getDate() + 6);
    } else if (endDate > maxDate) {
      // 撞到右邊牆壁 (昨天)：貼齊昨天，強制往前推滿 7 天
      endDate = new Date(maxDate);
      startDate = new Date(maxDate);
      startDate.setDate(startDate.getDate() - 6);
    }
    
    // 雙重防呆：如果往前推 6 天反而小於 minDate，再拉回來
    if (startDate < minDate) startDate = new Date(minDate);

    // 3. 跑 7 天迴圈，每天去字典拿資料 
    const loadChatLabels: string[] = [];
    const loadChatAvgData: (number | null)[] = [];
    const loadChatPeakLoadMaxData: (number | null)[] = [];
    const loadChatPeakLoadMinData: (number | null)[] = [];

    let hasAnyData = false; 

    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      const year = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');

      // 準備好 X 軸
      loadChatLabels.push(`${mm}/${dd}`);

      const targetKeyDash = `${dcode}_${year}-${mm}-${dd}`;
      const targetKeySlash = `${dcode}_${year}/${mm}/${dd}`;

      // 去字典裡面撈這一天專屬的資料
      const dayData = this.loadCurvDateDic[targetKeyDash] || this.loadCurvDateDic[targetKeySlash];

      if (dayData && typeof dayData === 'object') {
        hasAnyData = true;
        loadChatAvgData.push(dayData.AvgLoad !== undefined ? dayData.AvgLoad : null);
        loadChatPeakLoadMaxData.push(dayData.MaxLoad !== undefined ? dayData.MaxLoad : null);
        loadChatPeakLoadMinData.push(dayData.MinLoad !== undefined ? dayData.MinLoad : null);
      } else {
        loadChatAvgData.push(null);
        loadChatPeakLoadMaxData.push(null);
        loadChatPeakLoadMinData.push(null);
      }
    }

    // 4. 繪製圖表
    if (!hasAnyData) {
      this.loadDailog = false;
      return;
    }

    this.loadDailog = true;
    this.loadChart = {
      labels: loadChatLabels,
      datasets: [
        {
          label: 'Avg Load',
          data: loadChatAvgData,
          spanGaps: false,
          borderColor: 'rgba(54, 162, 235, 1)',
          backgroundColor: 'rgba(54, 162, 235, 0.1)',
          borderWidth: 2,
          fill: false,
          tension: 0.1
        },
        {
          label: 'Peak Load (Max)',
          data: loadChatPeakLoadMaxData,
          spanGaps: false,
          borderColor: 'rgba(255, 127, 39, 1)',
          backgroundColor: 'rgba(255, 127, 39, 0.1)',
          borderWidth: 2,
          fill: false,
          tension: 0.1
        },
        {
          label: 'Peak Load (Min)',
          data: loadChatPeakLoadMinData,
          spanGaps: false,
          borderColor: 'rgba(158, 158, 158, 1)',
          backgroundColor: 'rgba(158, 158, 158, 0.1)',
          borderWidth: 2,
          fill: false,
          tension: 0.1
        }
      ],
      options: {
        scales: {
          x: { grid: { display: true }, ticks: { display: true } },
          y: { grid: { display: true } }
        }
      }
    };
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
